
import globals from '../globals';
export default {
    data() {
        return {
            warning_msg:"",
        }
    },
    components: {
        globals
    },
    methods: {
        /*Create Products */
        async createProducts(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/products/", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        /*Get Products */
        async getProductsData(product_id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + "/products/"+ product_id);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getScmProducts(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.SCM_URL + "/products/get_product_by_id", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async deleteScmProducts(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.SCM_URL + "/products/delete_product", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        /*Update Products */
        async updateProducts(product_id,params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + "/products/"+ product_id,params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },

        /*Delete Products */
        async deleteProducts(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + "/products/delete",{
                        data: params
                    });
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        /*product List */
        async ListProducts(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/products/list", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async ProductsList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.SCM_URL + "/products/get_all_products", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async GetProductByID(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.SCM_URL + "/products/get_product_by_id", params);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){

                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/products.js